/**
 * @generated SignedSource<<85bf2b56a6723df5e4aeef112a2abe98>>
 * @relayHash c3acfc6893c692e62f72c6f67f50bbce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b3f08cecaf0ac72d3d618cb6145b5d5f04fae6aa9a10f71ad4025404442b4009

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFieldSetsMutationInput = {
  replaceFieldSetsInput?: JiraReplaceIssueSearchViewFieldSetsInput | null | undefined;
  resetToDefaultFieldSets?: boolean | null | undefined;
  scopedResetToDefaultFieldSets?: JiraScopedResetFieldsetsInput | null | undefined;
};
export type JiraReplaceIssueSearchViewFieldSetsInput = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  inclusive?: boolean | null | undefined;
  nodes: ReadonlyArray<string>;
};
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraScopedResetFieldsetsInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  doReset?: boolean | null | undefined;
};
export type useColumnsChangeMutation$variables = {
  amountOfColumns: number;
  fieldSetsInput?: JiraFieldSetsMutationInput | null | undefined;
  id: string;
  includeView: boolean;
};
export type useColumnsChangeMutation$data = {
  readonly jira: {
    readonly updateFieldSetsView: {
      readonly success: boolean;
      readonly view?: {
        readonly hasDefaultFieldSets: boolean | null | undefined;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useColumnsChangeMutation$rawResponse = {
  readonly jira: {
    readonly updateFieldSetsView: {
      readonly success: boolean;
      readonly view: {
        readonly __typename: "JiraFieldSetView";
        readonly fieldSets: {
          readonly __id?: string;
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly aliases: ReadonlyArray<string> | null | undefined;
              readonly displayName: string | null | undefined;
              readonly fieldSetId: string | null | undefined;
              readonly fieldSetPreferences: {
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly fieldType: {
                readonly displayName: string | null | undefined;
              } | null | undefined;
              readonly fieldsMetadata: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly canBeConfigured: boolean | null | undefined;
                    readonly fieldId: string | null | undefined;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly isPlaceHolderField?: boolean | null | undefined;
              readonly isSortable: boolean | null | undefined;
              readonly jqlTerm: string | null | undefined;
              readonly type: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
          readonly totalCount: number | null | undefined;
        } | null | undefined;
        readonly hasDefaultFieldSets: boolean | null | undefined;
        readonly id: string;
      } | {
        readonly __typename: string;
        readonly hasDefaultFieldSets: boolean | null | undefined;
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useColumnsChangeMutation = {
  rawResponse: useColumnsChangeMutation$rawResponse;
  response: useColumnsChangeMutation$data;
  variables: useColumnsChangeMutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": isJSCAliasChangesEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider: {
    readonly get: () => boolean;
  };
});

import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isJSCAliasChangesEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-alias-changes.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeView"
},
v4 = [
  {
    "kind": "Variable",
    "name": "fieldSetsInput",
    "variableName": "fieldSetsInput"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "success"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "hasDefaultFieldSets"
},
v8 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useColumnsChangeMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraFieldSetsViewPayload",
            "kind": "LinkedField",
            "name": "updateFieldSetsView",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "condition": "includeView",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "view",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "amountOfColumns",
                            "variableName": "amountOfColumns"
                          }
                        ],
                        "kind": "FragmentSpread",
                        "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "useColumnsChangeMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraFieldSetsViewPayload",
            "kind": "LinkedField",
            "name": "updateFieldSetsView",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "condition": "includeView",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "view",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "fieldSetSelectedState": "SELECTED"
                                }
                              },
                              {
                                "kind": "Variable",
                                "name": "first",
                                "variableName": "amountOfColumns"
                              }
                            ],
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueSearchFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueSearchFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "fieldSetId"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "type"
                                      },
                                      (v8/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "jqlTerm"
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "aliases"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "isSortable"
                                      },
                                      {
                                        "concreteType": "JiraFieldSetPreferences",
                                        "kind": "LinkedField",
                                        "name": "fieldSetPreferences",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "width"
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsMetadata",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueSearchMetadataField",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "canBeConfigured"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "isPlaceHolderField"
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraFieldType",
                                        "kind": "LinkedField",
                                        "name": "fieldType",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "totalCount"
                              },
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "JiraFieldSetView"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b3f08cecaf0ac72d3d618cb6145b5d5f04fae6aa9a10f71ad4025404442b4009",
    "metadata": {},
    "name": "useColumnsChangeMutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": isJSCAliasChangesEnabled_provider
    }
  }
};
})();

(node as any).hash = "23b7e8d0614dabcbd35090d188ce875b";

export default node;
